import { defAction } from "../../../../helpers/defaultAction"
import { reDistrictConstants } from "./constants"
import api from './api'

export const reDistrictActions = {
	getList,
	getListActualByRegion,
	clear
}

function getList(values){
	const dispatchObj = {
		constants : reDistrictConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getListActualByRegion(values){
	const dispatchObj = {
		constants : reDistrictConstants.getListActualByRegion,
		service   : {
			func   : api.getListActualByRegion,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reDistrictConstants.CLEAR
	})
}